import {Component, OnInit} from '@angular/core';
import {CategoryApi} from "../../../../common/apis/category-api";
import {Category} from "../../../../common/interfaces/Category";
import {Router} from "@angular/router";


@Component({
  selector: 'discover-us',
  templateUrl: './discover-us.component.html',
  styleUrls: ['./discover-us.component.scss']
})
export class DiscoverUsComponent implements OnInit {

  categories: Category[] = []
  allCategory = {
    id: "",
    name: "All"
  }

  constructor(
    private categoryApi: CategoryApi,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.categoryApi.getAllCategories(4).subscribe({
      next: (response) => {
        this.categories = response.data;//.slice(0, 4);
      }
    })
  }

  filterBy(category: Category) {
    if (category.name === "All") {
      this.router.navigate(["/restaurants"])
    } else {
      this.router.navigate(["/restaurants"], {
        queryParams: {
          "categoryId": category.id
        }
      })
    }
  }

}
